export const SIZE_LIMIT_EXCEEDED = 'SIZE_LIMIT_EXCEEDED';
export const UPLOAD_ERROR = 'UPLOAD_ERROR';
export const INVALID_FILE_TYPE = 'INVALID_FILE_TYPE';